import React, { useState, useEffect } from 'react';
import './CertificateCarousel.css';

const CertificateCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const certificates = [
    {
      image: '/Carousel/Certificate_IA%20CIA.png',
      alt: 'Certified Internal Auditor (CIA)',
      title: 'CIA - Certified Internal Auditor'
    },
    {
      image: '/Carousel/Certificate_IOSH%20Managing%20Safely.png',
      alt: 'IOSH Managing Safely',
      title: 'IOSH Managing Safely'
    },
    {
      image: '/Carousel/Certificate_ACFE_Certified%20Fraud%20Examiner.JPG',
      alt: 'Certified Fraud Examiner (CFE)',
      title: 'CFE - Certified Fraud Examiner'
    },
    {
      image: '/Carousel/Certificate_ISACA%20CISA.JPG',
      alt: 'Certified Information Systems Auditor (CISA)',
      title: 'CISA - Certified Information Systems Auditor'
    },
    {
      image: '/Carousel/Certificate_OCEG%20GRCA.png',
      alt: 'GRC Audit (GRCA)',
      title: 'GRCA - GRC Audit'
    },
    {
      image: '/Carousel/Certificate_OCEG%20GRCP.png',
      alt: 'GRC Professional (GRCP)',
      title: 'GRCP - GRC Professional'
    },
    {
      image: '/Carousel/Certificate_OCEG%20IPMP.png',
      alt: 'Integrated Policy Management Professional (IPMP)',
      title: 'IPMP - Integrated Policy Management Professional'
    }
  ];

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % certificates.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, certificates.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? certificates.length - 1 : prevIndex - 1
    );
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % certificates.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  return (
    <div className="certificate-carousel">
      <div className="carousel-container">
        <button 
          className="carousel-button prev" 
          onClick={goToPrevious}
          aria-label="Previous certificate"
        >
          <i className="fas fa-chevron-left"></i>
        </button>

        <div className="carousel-slides">
          <div 
            className="carousel-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {certificates.map((cert, index) => (
              <div key={index} className="carousel-slide">
                <div className="certificate-wrapper">
                  <img 
                    src={cert.image} 
                    alt={cert.alt}
                    loading="lazy"
                  />
                  <div className="certificate-title">{cert.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button 
          className="carousel-button next" 
          onClick={goToNext}
          aria-label="Next certificate"
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>

      <div className="carousel-indicators">
        {certificates.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to certificate ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CertificateCarousel;

